import { createApi } from '@reduxjs/toolkit/query/react'

import { NOTIFICATION_DISCOUNT_TYPE } from '~/redux/constants/tags.const'
import { apiPrivate } from '~/redux/utils/hom-api'
import { NotificationResponse } from '~/shared/types/notification.types'

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: apiPrivate,
  tagTypes: ['notification'],
  endpoints: (builder) => ({
    getNotification: builder.query<NotificationResponse, { pageNo?: number }>({
      query: (params) => ({
        url: '/v1/notification',
        method: 'GET',
        params,
      }),
      providesTags: ['notification'],
    }),
    setBadgeNotification: builder.mutation<
      { success: boolean },
      { imagePath: string; subject: string; category: string }
    >({
      query: (body) => ({
        url: '/v1/notification/badge',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['notification'],
    }),
    setDiscountNotification: builder.mutation<void, { discountType: NOTIFICATION_DISCOUNT_TYPE }>({
      query: (body) => ({
        url: 'v1/notification/discount',
        method: 'POST',
        body,
      }),
    }),
    setMarkAsRead: builder.mutation<{ success: boolean }, { notificationIds: number[] }>({
      query: (body) => ({
        url: '/v1/notification/mark-as-read',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['notification'],
    }),
    setMarkAsOld: builder.mutation<{ success: boolean }, void>({
      query: () => ({
        url: '/v1/notification/mark-as-old',
        method: 'POST',
      }),
      invalidatesTags: ['notification'],
    }),
  }),
})

export const {
  useGetNotificationQuery,
  useLazyGetNotificationQuery,
  useSetMarkAsReadMutation,
  useSetMarkAsOldMutation,
  useSetBadgeNotificationMutation,
  useSetDiscountNotificationMutation,
} = notificationApi
